export const COVER_MAX_BYTES = 550 * 1024;
